import { getContext } from 'svelte';
import type { createTimeContext } from '../createTimeContext/createTimeContext';
import { Contexts } from '#lib/constants/contexts.js';

export const getTimeContext = () => {
	return getContext<ReturnType<typeof createTimeContext>>(Contexts.Now);
};
